import { render } from "./InventoryForm.vue?vue&type=template&id=9ffce1ce&scoped=true"
import script from "./InventoryForm.vue?vue&type=script&lang=js"
export * from "./InventoryForm.vue?vue&type=script&lang=js"

import "./InventoryForm.vue?vue&type=style&index=0&id=9ffce1ce&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ffce1ce"]])

export default __exports__